/**
 * The menu route IDs that can be used for route resolvers
 */
export enum MenuRoute {
  COMMUNITY_PAGE = 'community-page',
  COLLECTION_PAGE = 'collection-page',
  ITEM_PAGE = 'item-page',
}
